@import '@alfalab/core-components-vars/src/safe-area.css';
@import '../../vars.css';

.header {
    padding: var(--modal-header-mobile-paddings);

    @media (display-mode: standalone) {
        padding-top: calc(var(--sat) + var(--modal-header-mobile-top-padding));
    }
}

.sticky {
    top: var(--gap-0);
}

.content {
    padding: var(--modal-header-mobile-content-paddings);
    @mixin headline-system-mobile_small;
}
